export async function apiFetch(url, options = {}) {
  const r = await fetch(url, options);
  if (!r.ok) throw {response: {status: r.status}};
  return {data: await r.json()};
}
